import { render } from "./TheNhomQuyenQT.vue?vue&type=template&id=78499020"
import script from "./TheNhomQuyenQT.vue?vue&type=script&lang=js"
export * from "./TheNhomQuyenQT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__